const source = 'clientiDataTable'
//const source = 'FattureClientiDataTable'

function setMassivoSDI() {
  console.log(this.filtered);
  
  const keys = Object.keys(this.filtered.ids).filter((s) => s == source)
  if(keys.length > 0){    
    this.$eventBus.emit('show-dialog-page', {
      page: 'MassivoSdi',
      title: 'Caricamento massivo sdi',
      data: this.filtered.items[source],
      maximize: false,

      buttonOk: {
        label: 'Chiudi',
        icon: 'pi pi-times',
        class: 'p-button-text',
        visible: true,
        disabled: false,
      },

      buttonCancel: {
        label: '',
        icon: '',
        class: '',
        visible: false,
        disabled: false,
      },
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': setMassivoSDI,
}
